S.counterElement =
    {
        config: {
            countto: null,
            counttime: 800,
            intervaltime: 100,
        },

        elements: {
            $counter: null,
        },

        init()
        {
            let count = 0;

            if (this.isInViewport(this.$module) === true)
            {
                this.countUp();
                count = 1;
            }

            $(window).on('scroll', () =>
            {
                if (count === 0 && this.isInViewport(this.$module) === true)
                {
                    this.countUp();
                }
                if (this.isInViewport(this.$module) === true)
                {
                    count = 1;
                }
                else
                {
                    count = 0;
                }
            });
        },


        // returns true if the element is in the visible area
        isInViewport($element)
        {
            const elementTop = $element.offset().top,
                elementBottom = elementTop + $element.outerHeight(),
                viewportTop = $(window).scrollTop(),
                viewportBottom = viewportTop + $(window).height();

            return elementBottom > viewportTop && elementTop < viewportBottom;
        },

        /**
         * Count from 0 to initial counter
         * higher digits added for high initial counters
         * interval used for adding up until inital counter reached then interval is cleared
         */
        countUp()
        {
            const currentCounter = this.elements.$counter;
            const initialCounter = this.config.countto;
            const nf = Intl.NumberFormat();
            // const onCountingFormatted = '';
            let onCounting = 1;
            let add = Math.round(initialCounter / (this.config.counttime / this.config.intervaltime));

            if (add === 0)
            {
                add = 1;
                this.config.intervaltime = this.config.counttime / initialCounter;
            }

            currentCounter.text(1);

            // console.log(add);
            const interval = setInterval(() =>
            {
                if (onCounting === initialCounter)
                {
                    clearInterval(interval);
                }
                else
                {
                    onCounting += add;
                    if (onCounting > initialCounter)
                    {
                        onCounting = initialCounter;
                    }

                    currentCounter.text(nf.format(onCounting));
                }
            }, this.config.intervaltime);
        },
    };
